import React from 'react';

import { createPortal } from 'react-dom';

type PrintViewContainerProps = {
  onClose?: () => void;
};

export const PrintViewContainer: React.FC<React.PropsWithChildren<PrintViewContainerProps>> = ({
  children,
  onClose,
}) => {
  const printViewRootRef = React.useRef(document.getElementById('app-print'));

  const isPrintCalled = React.useRef(false);

  React.useEffect(() => {
    if (!isPrintCalled.current) {
      setTimeout(() => {
        window.print();
      });
      isPrintCalled.current = true;
    }
  }, []);

  React.useEffect(() => {
    const afterPrintEvent = () => {
      onClose?.();
    };

    window.addEventListener('afterprint', afterPrintEvent);

    return () => {
      window.removeEventListener('afterprint', afterPrintEvent);
    };
  }, [onClose]);

  return printViewRootRef.current !== null
    ? createPortal(children, printViewRootRef.current)
    : null;
};
